import axios from "@/api/axios";

const getRenewalInfo = (data) => {
    return axios
        .post('/admin/renewal/monitor-info', {renewal: data})
        .then(response => response.data)
}

const getNotaskDeals = (data) => {
    return axios
        .post('/admin/renewal/notask-deals', {renewal: data})
        .then(response => response.data)
}

const getActiveDeals = (data) => {
    return axios
        .post('/admin/renewal/active-deals', {renewal: data})
        .then(response => response.data)
}

const getRenewalNewTasks = (data) => {
    return axios
        .post('/admin/renewal/new-tasks', {renewal: data})
        .then(response => response.data)
}

const getRenewalOverdueTasks = (data) => {
    return axios
        .post('/admin/renewal/overdue-tasks', {renewal: data})
        .then(response => response.data)
}

const getStagesDeals = (data) => {
    return axios
        .post('/admin/renewal/stages-deals',{renewal: data})
        .then(response => response.data)
}

const getMembershipExtension = (data) => {
    return axios
        .post('/admin/renewal/membership-extension',{renewal: data})
        .then(response => response.data)
}

const getPackageExtension = (data) => {
    return axios
        .post('/admin/renewal/package-extension',{renewal: data})
        .then(response => response.data)
}

const getMembershipNodeals = (data) => {
    return axios
        .post('/admin/renewal/membership-nodeals',{renewal: data})
        .then(response => response.data)
}

const getPackageNodeals = (data) => {
    return axios
        .post('/admin/renewal/package-nodeals',{renewal: data})
        .then(response => response.data)
}

const getDealsStageRenewal = (data) => {
    return axios
        .post('/admin/renewal/deals-stage',{renewal: data})
        .then(response => response.data)
}

export default {
    getRenewalInfo,
    getNotaskDeals,
    getActiveDeals,
    getRenewalNewTasks,
    getRenewalOverdueTasks,
    getStagesDeals,
    getMembershipExtension,
    getPackageExtension,
    getMembershipNodeals,
    getPackageNodeals,
    getDealsStageRenewal
}